var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"tab-pane form-comment",attrs:{"id":"description","role":"tabpanel","aria-expanded":"false"}},[_c('article',[_c('div',{staticClass:"text-p-description",domProps:{"innerHTML":_vm._s(_vm.description)}})])])}
var staticRenderFns = []

export { render, staticRenderFns }